import { SelectionFamilyReferenceAdoption, SelectionIndividualEvent } from './internal';
export class SelectionIndividualEventFamilyAdoption extends SelectionIndividualEvent {
    getFamilyAsChildReference() {
        return this.get("FAMC" /* Tag.FamilyChild */, null, SelectionFamilyReferenceAdoption);
    }
}
//# sourceMappingURL=SelectionIndividualEventFamilyAdoption.js.map